import React from "react";
import { FileText, ShieldCheck } from "lucide-react";

function Doc() {
  const docs = [
    {
      title: "Documentación para empleados",
      description:
        "Guía de uso de la plataforma, procedimientos y funciones disponibles para empleados.",
      icon: <FileText size={26} color="white" />,
      bg: "#2563eb",
      pdf: "/docs/MANUAL_EMPLEADOS.pdf",
    },
    {
      title: "Documentación para administradores",
      description:
        "Manual de administración, configuración y gestión avanzada del sistema.",
      icon: <ShieldCheck size={26} color="white" />,
      bg: "#16a34a",
      pdf: "/docs/MANUAL_ADMINISTRADORES.pdf",
    },
  ];

  return (
    <div>
      <h1 className="tn-page-title">Documentación</h1>
      <p className="tn-page-sub">
        Consulta los manuales de uso según tu perfil.
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill,minmax(320px,1fr))",
          gap: 16,
          marginTop: 20,
        }}
      >
        {docs.map((doc) => (
          <div
            key={doc.pdf}
            className="tn-card tn-card--hover"
            style={{ padding: 24 }}
          >
            <div
              style={{
                width: 52,
                height: 52,
                borderRadius: 12,
                background: doc.bg,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 16,
              }}
            >
              {doc.icon}
            </div>

            <h3
              style={{
                fontSize: 16,
                fontWeight: 700,
                color: "var(--clr-text)",
                marginBottom: 8,
              }}
            >
              {doc.title}
            </h3>

            <p
              style={{
                fontSize: 13.5,
                color: "var(--clr-muted)",
                marginBottom: 20,
                lineHeight: 1.5,
              }}
            >
              {doc.description}
            </p>

            <a
              href={doc.pdf}
              target="_blank"
              rel="noopener noreferrer"
              className="tn-btn tn-btn--primary"
              style={{
                display: "inline-flex",
                textDecoration: "none",
              }}
            >
              Abrir PDF
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Doc;